// @flow
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Waypoint } from 'react-waypoint';
import bgImage from 'assets/images/background.png';
import goalcardImage from 'assets/images/goalcard_gift.svg';
import searchBoxImage from 'assets/images/search_icon.svg';
import { getColor } from 'utils/color';
import MiniLoader from 'components/shared/MiniLoader/MiniLoader';
import giftActions from 'actions/gift';
import { sendAnalyticsEvent } from 'utils/analyticsWrapper';
import PopUpShowerQR from 'components/shared/PopUpShowerQR/PopUpShowerQR';
import FamilyMemberContainer from './FamilyMemberContainer';

const SectionContainer = styled.div`
  position: relative;
  background-size: cover;
  background-repeat: no-repeat;
  color: #fff;
  font-size: .85em;
  text-align: center;
`;

const Container = styled.div`
  box-sizing: unset;
  -webkit-box-sizing: unset;
  margin: 0 auto;
`;

const HeadingTitle = styled.div`
  font-size: 26px;
  font-family: "Avenir Next LT W01 Demi";
  padding-top: 65px;
`;

const HeadingSubtitle = styled.div`
  padding-top: 25px !important;
  padding-bottom: 120px;
  font-size: 14px;
  max-width: 430px;
  line-height: 1.7em;
  font-weight: bold;
  margin-top: 0px;
  margin-right: auto;
  margin-bottom: 0px;
  margin-left: auto;
`;

const ImageContainer = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: center;
`;

const Image = styled.img`
  flex: 1;
  margin-top: -70px;
  position: absolute;
`;

const SearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap
  align-self:center;
  align-content:strech;
  margin: 60px auto;
  padding: 0px 20px;
  max-width: 440px;
  text-align: center;
`;

const SearchInputGroup = styled.div`
  font-family: "Avenir Next LT W01 Demi";
  display: inline-flex;
  flex-direction: flow;
  min-width:100%;
  align-items:center;
  border-bottom: 1px solid #00b7d5;
  font-size: 14px;
  height: 35px;
  margin: 45px 0px;

`;

const SearchLabel = styled.label`
  font-size: 14px;
  color: #00b7d5;
  margin 2px 7px;
`;

const SearchInput = styled.input`
  font-size: 14px;
  color: #00b7d5;
  height: 32px;
  border: none;
  background: none;
  outline: none;
  width:90%;
  margin-bottom:1px;
  
  ::-webkit-input-placeholder {
    opacity: 0.8 !important;
    color: grey !important
  }

  ::-moz-placeholder {
    opacity: 0.8 !important;
    color: grey !important
  }
  
  ::-ms-input-placeholder {
    opacity: 0.8 !important;
    color: grey !important
  }
`;

const SearchImage = styled.img`
  cursor:pointer;
  margin 2px 7px;
`;

const ResultsContainer = styled.div`
  margin-bottom: 50px;
  min-width: 100%;
  display: inline-flex;
  flex-direction: column;
`;

const NoMatchesContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const NoMatchesTitle = styled.h3`
  font-size: 20px;
  align-self: center;
  color: #000;
  font-weight: 900;
  margin-bottom: 25px;
`;

const NoMatchesDescription = styled.p`
  font-size: .95em;
  margin: .4em 0 .7em;
  line-height: 1.6em;
  font-family: "AvenirNextLTW01-Regular";
  color: #000;
  font-weight: 900;
  margin-top: 0px;
  margin-bottom: 40px;
  align-self: center;
`;

const NoMatchesFor = styled.span`
`;

const StyledLink = styled.div`
    text-decoration: none;
    background-color: #F3A802;
    font-weight: 900;
    width: 140px;
    height: 40px;
    font: normal 16px/21px 'Avenir Next LT W01 Demi';
    padding: 10px 15px;
    border-radius: 6px;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    color: #fff;
    border: none;
    align-self: center;
    cursor: pointer;

    &:focus, &:hover, &:visited, &:link, &:active {
        text-decoration: none;
    }
`;

type GiftPageProps = {
  getFamilyMembers: Function,
  setGoalcardReceiver: Function
};

const GiftPage = (props: GiftPageProps) => {
  const history = useHistory();

  const [pageState, updatePageState]: [any, ((any => any) | any) => void] = useState({});
  const { getFamilyMembers, setGoalcardReceiver } = props;
  useEffect(() => {
    updatePageState({
      index: 1,
      familyMembers: [],
    });
  }, []);

  const { t } = useTranslation();

  const GetFamilyMembers = (newSearch) => {
    updatePageState({ ...pageState, isProcessing: true });
    let { index, familyMembers, hasNewResults } = pageState;

    if (newSearch) {
      index = 1;
      hasNewResults = false;
      familyMembers = [];
    } else {
      index += 1;
    }

    getFamilyMembers(pageState.searchValue, index).then((results) => {
      hasNewResults = results && results.length > 0;

      if (newSearch) {
        familyMembers = results;
      } else {
        familyMembers = hasNewResults
          ? [...pageState.familyMembers, ...results]
          : [...pageState.familyMembers];
      }

      updatePageState({
        ...pageState,
        searchDone: true,
        index,
        familyMembers,
        hasNewResults,
        searchedValue: pageState.searchValue,
        isProcessing: false,
      });
    });
  };

  const RenderLoader = () => {
    if (pageState.isProcessing) {
      return <MiniLoader show />;
    }

    return null;
  };

  const onKeyDownInput = (event) => {
    if (event.key === 'Enter') {
      sendAnalyticsEvent('Gift', 'search_public_profiles_enter');
      GetFamilyMembers(true);
    }
  };

  const onClick = () => {
    sendAnalyticsEvent('Gift', 'search_public_profiles_click');
    GetFamilyMembers(true);
  };

  const onChangeInput = (event) => {
    updatePageState({
      ...pageState,
      searchValue: event.target.value,
    });
  };

  const handleScroll = () => {
    if (pageState.searchDone && pageState.searchDone === true && pageState.hasNewResults) {
      sendAnalyticsEvent('Gift', 'search_public_profiles_scrolldown');
      GetFamilyMembers(false);
    }
  };

  const onSelect = (receiverUser) => {
    setGoalcardReceiver(receiverUser);
    sendAnalyticsEvent('Gift', 'search_public_profiles_selectuser');

    history.push('/selectgoalcard');
  };

  const onSelectNonUser = (receiverUser) => {
    setGoalcardReceiver(receiverUser);

    sendAnalyticsEvent('Gift', 'search_public_profiles_selectnonuser');
    history.push('/selectgoalcard');
  };

  const RenderDivNoResults = () => {
      return (
        <NoMatchesContainer>
          <NoMatchesTitle>{t('gift_nomatches_title')}</NoMatchesTitle>
          <NoMatchesDescription>
            {t('gift_nomatches_description')}
            <NoMatchesFor>{pageState.searchedValue}</NoMatchesFor>
          </NoMatchesDescription>
          <StyledLink data-testid="btnContinue" onClick={() => onSelectNonUser({ fullName: pageState.searchValue })}>
            {t('continue_title')}
          </StyledLink>
        </NoMatchesContainer>
      );
  };

  const Break = ({index, isLast }) => {
    if ((index > 0 && (index % 10) === 0) || isLast) {
      return <RenderDivNoResults />;
    }

    return null;
  };

  const LoadFamilyMembers = () => {
    if (pageState.familyMembers && pageState.familyMembers.length > 0) {
      return (
        <>
          {pageState.familyMembers.map((familyMember, index, array) => (
            <>
              <FamilyMemberContainer
                key={familyMember.rid}
                familyMember={familyMember}
                familyMemberChilds={familyMember.members}
                color={getColor(index)}
                onSelect={onSelect}
                query={pageState.searchValue}
              />
              { 
                (pageState.searchValue.includes('$') === false) && 
                <Break index={index+1} isLast={array.length - 1 === index}/> 
              }
            </>
          ))}
        </>
      );
    }

    if (pageState.searchDone && pageState.searchDone === true) {
      if(pageState.familyMembers.length < 1)
        return RenderDivNoResults();
    }

    return null;
  };

  return (
    <>
      <SectionContainer style={{ backgroundImage: `url(${bgImage})` }}>
        <Container>
          <HeadingTitle>{t('gift_title')}</HeadingTitle>
          <HeadingSubtitle>
            {t('gift_description')}
          </HeadingSubtitle>
        </Container>
        <ImageContainer>
          <Image alt="Goalcard" src={goalcardImage} />
        </ImageContainer>
      </SectionContainer>
      <SearchContainer>
        <SearchInputGroup>
          <SearchLabel>To:</SearchLabel>
          <SearchInput data-testid="inputEmail" placeholder={t('gift_search_placeholder')} onChange={onChangeInput} onKeyDown={onKeyDownInput} />
          <SearchImage data-testid="btnSearch" src={searchBoxImage} alt="Search" onClick={onClick} />
        </SearchInputGroup>
        <ResultsContainer>
          {LoadFamilyMembers()}
          {RenderLoader()}
        </ResultsContainer>
        <Waypoint onEnter={handleScroll} />
      </SearchContainer>
    </>
  );
};

// Map Props
const mapStateToProps = (state) => ({
  isProcessing: state.gift.isProcessing,
  familyMembers: state.gift.familyMembers,
});

// Map Dispatch
const mapDispatchToProps = (dispatch) => ({
  getFamilyMembers: (searchValue: string, index: int) => dispatch(
    giftActions.getFamilyMembers(searchValue, index),
  ),
  setGoalcardReceiver: (receiver: Any) => dispatch(
    giftActions.setGoalcardReceiver(receiver),
  ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GiftPage);
